var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.589844,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#003588"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_4616)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_80_4616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 27.4638L25.125 32.4219C27.1983 34.0343 28.2349 34.8405 29.4189 34.998C29.8049 35.0493 30.1961 35.0493 30.5821 34.9979C31.7661 34.8404 32.8027 34.0342 34.8759 32.4217L41.25 27.4638M25.125 21.8807L21.8159 24.4543C20.4803 25.493 19.8125 26.0124 19.3911 26.7062C19.2521 26.935 19.1342 27.176 19.0389 27.4263C18.75 28.1848 18.75 29.0308 18.75 30.7228V33.8976C18.75 37.2062 18.75 38.8605 19.5926 40.0202C19.8647 40.3947 20.1941 40.7241 20.5686 40.9962C21.7283 41.8388 23.3826 41.8388 26.6912 41.8388H33.3088C36.6174 41.8388 38.2717 41.8388 39.4314 40.9962C39.8059 40.7241 40.1353 40.3947 40.4074 40.0202C41.25 38.8605 41.25 37.2062 41.25 33.8976V30.7225C41.25 29.0307 41.25 28.1847 40.9611 27.4263C40.8658 27.176 40.7479 26.935 40.609 26.7062C40.1876 26.0124 39.5198 25.493 38.1844 24.4543L34.8759 21.8809C32.8027 20.2684 31.7661 19.4621 30.5821 19.3046C30.1961 19.2533 29.8049 19.2533 29.4189 19.3046C28.2349 19.462 27.1983 20.2682 25.125 21.8807Z",
    stroke: "#FAFCFF",
    strokeWidth: 1.32353,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 27.4638L25.125 32.4219C27.1983 34.0343 28.2349 34.8405 29.4189 34.998C29.8049 35.0493 30.1961 35.0493 30.5821 34.9979C31.7661 34.8404 32.8027 34.0342 34.8759 32.4217L41.25 27.4638M25.125 21.8807L21.8159 24.4543C20.4803 25.493 19.8125 26.0124 19.3911 26.7062C19.2521 26.935 19.1342 27.176 19.0389 27.4263C18.75 28.1848 18.75 29.0308 18.75 30.7228V33.8976C18.75 37.2062 18.75 38.8605 19.5926 40.0202C19.8647 40.3947 20.1941 40.7241 20.5686 40.9962C21.7283 41.8388 23.3826 41.8388 26.6912 41.8388H33.3088C36.6174 41.8388 38.2717 41.8388 39.4314 40.9962C39.8059 40.7241 40.1353 40.3947 40.4074 40.0202C41.25 38.8605 41.25 37.2062 41.25 33.8976V30.7225C41.25 29.0307 41.25 28.1847 40.9611 27.4263C40.8658 27.176 40.7479 26.935 40.609 26.7062C40.1876 26.0124 39.5198 25.493 38.1844 24.4543L34.8759 21.8809C32.8027 20.2684 31.7661 19.4621 30.5821 19.3046C30.1961 19.2533 29.8049 19.2533 29.4189 19.3046C28.2349 19.462 27.1983 20.2682 25.125 21.8807Z",
    stroke: "#FAFCFF",
    strokeWidth: 1.32353,
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_4616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(15 15.5898)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_80_4616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(15 15.5898)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b31737d2824cd6db31afbbca10e4fbb4.svg";
export { ForwardRef as ReactComponent };